import { Entity } from '@api';
import { TFunction } from 'i18next';

import { SectorDistribution } from '../useIndustrySectorDistributions';

export const getDistributions = (
  entities: Entity[],
  t: TFunction
): SectorDistribution[] => {
  const sectorToCountMap = entities.reduce<Record<string, number>>(
    (acc, entity) => {
      const sector = entity.gics.sector.code;
      acc[sector] = (acc[sector] ?? 0) + 1;
      return acc;
    },
    {}
  );

  const totalSectorCount = Object.values(sectorToCountMap).reduce(
    (a, b) => a + b,
    0
  );

  const distributions = Object.entries(sectorToCountMap)
    .map(([sector, sum]) => ({
      name: t(`widget:assetOverview.companyProfile.sectorNames.${sector}`),
      value: sum / totalSectorCount,
    }))
    .sort((a, b) => b.value - a.value);

  const sectorDistributions = distributions.slice(0, 4);
  const otherSectors = distributions.slice(4);

  if (otherSectors.length) {
    const otherPercentages = otherSectors.reduce(
      (acc, dist) => acc + dist.value,
      0
    );
    sectorDistributions.push({
      name: t('widget:assetOverview.companyProfile.sectorNames.sector_other'),
      value: otherPercentages,
    });
  }

  return sectorDistributions;
};
